import {Component, ChangeDetectionStrategy} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {API_BASE_URL, STORAGE_LOCATION_ARTICLES_URL} from "../utility/constants/api.constants";
import {Article, ImportArticle} from "@knust/api-interfaces";
import {Router} from "@angular/router";
import {
  importArticleColumnConfig,
  importArticleCommandMap,
  importArticleDisplayedColumns
} from "./import-article-table";
import {ConfirmComponent} from "../reusable-components/confirm/confirm.component";
import {MatDialog} from "@angular/material/dialog";
import {deleteImportArticle, loadImportArticle} from "./+state/import-article.actions";
import {Store} from "@ngrx/store";
import {StorageLocationArticleService} from "../utility/services/storage-location-article.service";
import {createArticle, saveArticleFailure, saveArticleSuccess} from "../articles/+state/article.actions";
import {Actions, ofType} from "@ngrx/effects";
import {filter, first} from "rxjs";

@Component({
    selector: 'knust-import',
    templateUrl: './import.component.html',
    styleUrls: ['./import.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImportComponent {
  selectedFile = undefined;
  commandMap = importArticleCommandMap;
  displayedColumns = importArticleDisplayedColumns;
  columnConfig = importArticleColumnConfig;

  constructor(private http: HttpClient,
              private dialog: MatDialog,
              private store: Store,
              private storageLocationArticleService: StorageLocationArticleService,
              private router: Router,
              private actions$: Actions) {}

  selectFile(event: any): void {
    this.selectedFile = event.target.files[0];
  }

  upload() {
    if (this.selectedFile) {
      const fd = new FormData();
      fd.append('file', this.selectedFile);

      this.http.post(API_BASE_URL + '/import/upload', fd).subscribe(
        () => {
          this.store.dispatch(loadImportArticle());
        }
      );
    }
  }

  navigateToArticleEditing(article: Article) {
    this.router.navigate(['/', 'artikel', 'neu'], { state: { article }});
  }

  saveImportArticle(importArticle: ImportArticle) {
    // Die ID des Importartikels darf nicht mitgeschickt werden: Die API würde sonst einen bestehenden
    // Artikel mit derselben ID überschreiben, statt einen neuen anzulegen.
    const { id: _id, createdDate: _createdDate, updatedDate: _updatedDate, ...articleData } = importArticle;

    // Den Importartikel erst nach erfolgreicher Anlage löschen: Schlägt die Anlage fehl, bleibt er erhalten,
    // ansonsten verschwindet er aus der Liste und kann nicht doppelt übernommen werden.
    this.actions$.pipe(
      ofType(saveArticleSuccess, saveArticleFailure),
      first(),
      filter(action => action.type === saveArticleSuccess.type && action.insert),
    ).subscribe(() => {
      this.store.dispatch(deleteImportArticle({ id: importArticle.id, noMessage: true }));
    });

    this.store.dispatch(
      createArticle({
        article: {
          notificationStatus: 0,
          preAssignWithdrawal: 0,
          ...articleData,
        }
      })
    );
  }

  deleteImportArticle(article: ImportArticle) {
    this.dialog.open(ConfirmComponent, {
      data: {
        title: 'Importierten Artikel wirklich löschen?',
        text: 'Möchten Sie diesen importierten Artikel wirklich löschen?',
        buttonColor: 'warn'
      }
    })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.store.dispatch(deleteImportArticle({ id: article.id }));
        }
      })
  }

  exportArticles() {
    this.storageLocationArticleService.exportStorageLocationArticles().subscribe(downloadObject => {
      const a = document.createElement("a");
      a.href = STORAGE_LOCATION_ARTICLES_URL + '/export/' + downloadObject.filePath;
      const filename = "artikel-export";
      a.setAttribute("download", filename + ".csv");
      a.setAttribute("target", "_blank");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  }
}
